import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useResizeObserver } from '@vueuse/core';
import { CSSProperties, nextTick, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VCollapse',
  props: {
    title: null
  },
  setup(__props: any, { expose }) {

const props = __props as { title?: string }



const opened = ref(false)
const style = ref<CSSProperties>({ display: "none" })
const innerRef = ref<HTMLElement>()

useResizeObserver(innerRef, () => {
  if (!opened.value) return
  console.log("calc")
  calc()
})

const calc = () => {
  if (opened.value) {
    style.value = { display: "block", height: "0px" }
    nextTick(() => {
      if (!opened.value) return
      style.value = { height: innerRef.value!.clientHeight+"px" }
    })
  } else {
    style.value = { height: "0px" }
    setTimeout(() => {
      if (opened.value) return
      style.value = { display: "none", height: "0px" }
    }, 120)
  }
}

watch(opened, () => {
  calc()
})

const onHeaderClick = (e: MouseEvent) => {
  e.preventDefault()
  e.stopPropagation()
  opened.value = !opened.value
}

expose({
  open() {
    opened.value = true
  },
  close() {
    opened.value = false
  }
})


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["v-collapse", { opened: opened.value }])
  }, [
    _renderSlot(_ctx.$slots, "activator", {
      opened: opened.value,
      toggle: onHeaderClick
    }, () => [
      _createElementVNode("button", {
        class: "v-collapse__header",
        onClick: onHeaderClick
      }, [
        _createTextVNode(_toDisplayString(props.title) + " ", 1),
        _createVNode(_component_v_icon, {
          class: "down-arrow-icon ml-2",
          icon: "mdi-chevron-down"
        })
      ])
    ]),
    _createElementVNode("div", {
      class: "v-collapse__content",
      style: _normalizeStyle(style.value)
    }, [
      _createElementVNode("div", {
        class: "v-collapse__inner",
        ref_key: "innerRef",
        ref: innerRef
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 512)
    ], 4)
  ], 2))
}
}

})